import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { useAppSelector, useAppDispatch } from '../../hooks';
import { setPortalProfileMenuOpen } from '../../store/portal/portalActions';
import { UserModel } from '../../types';
import { BLink, BText } from '..';
import { Avatar } from '..';
import { themeHeader } from '../../styles';

type ProfilePropsType = {
  data: UserModel;
};
type MenuItemType = {
  label?: string;
  screen?: string;
  pathname?: string;
  type?: string;
};

export const ProfileMenu = ({ data }: ProfilePropsType) => {
  const dispatch = useAppDispatch();

  const [rtPortal, rtMyEvents, rtMyFav] = useAppSelector(s => [s.portal, s.myEvent, s.myFavorites]);

  const [isOpen, setIsOpen] = useState<boolean | number>(false);

  useEffect(() => {
    setIsOpen(rtPortal.headerProfileMenuOpen);
  }, [rtPortal.headerProfileMenuOpen]);

  const handleMenuToggle = () => {
    let newStatus = !isOpen;
    setIsOpen(newStatus);
    dispatch(setPortalProfileMenuOpen(newStatus));
  };

  const handleMenuItemPress = (item: MenuItemType) => {
    setIsOpen(false);
    dispatch(setPortalProfileMenuOpen(false));
  };

  const menuItems: MenuItemType[] = [
    {
      label: 'Profile',
      screen: 'my-setting-profile',
      pathname: '/my-settings/my-setting-profile', // for web: only for special case
    },
    { type: 'divider' },
    {
      label: `My Events${rtMyEvents ? ` (${rtMyEvents.allEvents.length})` : ''}`,
      screen: 'my-events',
    },
    { label: `My Favorites ${rtMyFav ? ` (${rtMyFav.allEvents.length})` : ''}`, screen: 'my-favorites' },
    { type: 'divider' },
    { label: 'Task Management', screen: 'admin-portal' },
    { type: 'divider' },
    { label: 'Settings', screen: 'my-settings' },
    { type: 'divider' },
    { label: 'Logout', screen: 'logout' },
  ];

  return (
    <View style={themeHeader.dropdown.container}>
      <TouchableOpacity onPress={handleMenuToggle}>
        <Avatar text={data?.intialName} size={24} />
        {/*<BText style={styles.menuButton}>Hi </BText>*/}
      </TouchableOpacity>

      {isOpen && (
        <View style={themeHeader.dropdown.menuList}>
          <View style={themeHeader.dropdown.menuItemHeader}>
            <Avatar text={data?.intialName} size={24} style={themeHeader.dropdown.menuItem} />
            <BText style={themeHeader.dropdown.menuItemHeaderText}>{data?.name || 'Name'}</BText>
          </View>

          {menuItems.map((item, idx) => (
            <TouchableOpacity
              key={idx}
              onPress={() => handleMenuItemPress(item)}
              style={themeHeader.dropdown.menuItem}
              activeOpacity={0.7}
            >
              {item?.type === 'divider' && <View style={themeHeader.dropdown.menuDivider} />}
              {item.type === undefined && (
                <BLink to={{ screen: item.screen, pathname: item.pathname }} style={themeHeader.dropdown.menuItemText}>
                  {item.label}
                </BLink>
              )}
            </TouchableOpacity>
          ))}
        </View>
      )}
    </View>
  );
};
